const SUPPORTED_LANGUAGES = [
  'ar', 'az', 'bg', 'bn', 'ca', 'chr', 'cs', 'da', 'de', 'el', 'en-GB', 'en-US', 'en-XM', 'es', 'es-419', 'et', 'fa',
  'fi', 'fr', 'fr-CA', 'hi', 'hr', 'hu', 'id', 'it', 'ja', 'ko', 'lld', 'lt', 'lv', 'mi', 'mk', 'mr', 'my', 'nb', 'nl',
  'pl', 'pt', 'pt-BR', 'ro', 'ru', 'sk', 'sl', 'sr', 'sr-Latn', 'sv', 'ta', 'th', 'tr', 'uk', 'vi', 'zh-CN', 'zh-HK',
  'zh-TW',
];

export const isUserLanguageSupported = (userLanguage: string) => {
  if (SUPPORTED_LANGUAGES.find((language) => language === userLanguage)) {
    return userLanguage;
  }

  if (userLanguage.includes('-')) {
    const formattedUserLanguage = userLanguage.split('-')[0];

    if (SUPPORTED_LANGUAGES.find((language) => language === formattedUserLanguage)) {
      return formattedUserLanguage;
    }
  }

  return 'en-US';
};
